import { render, staticRenderFns } from "./vendorAfterSale.vue?vue&type=template&id=72c1b5b9&scoped=true"
import script from "./vendorAfterSale.vue?vue&type=script&lang=js"
export * from "./vendorAfterSale.vue?vue&type=script&lang=js"
import style0 from "./vendorAfterSale.vue?vue&type=style&index=0&id=72c1b5b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1b5b9",
  null
  
)

export default component.exports